import Vue from "vue"
import permission from "./permission"
import dict from "./dict"
Vue.directive("permission", permission);
Vue.directive("dict", dict);



// WEBPACK FOOTER //
// ./src/directive/index.js